import React, { PropTypes } from 'react';

import { NitroParagraph, NitroModal } from 'nitro-components';

import styled from 'styled-components';

const Content = styled.div`
	max-width: 400px;
`;

const ConfirmDeleteModal = ({ open, close, action }) => {
	return (
		<NitroModal
			variant="notification"
			action={action}
			close={close}
			isOpen={open}
			actionLabel="Yes, delete all"
			cancelLabel="Cancel"
			buttonLayout="inverseHorizontal"
			headingVariant="notification"
			title={`Delete all notifications ?`}
		>

			<Content>
				<NitroParagraph align="center">
					{`All your notifications will be permanently deleted and cannot be viewed again.`}
				</NitroParagraph>
			</Content>
		</NitroModal>
	);
};

ConfirmDeleteModal.propTypes = {
	close: PropTypes.func.isRequired,
	action: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired
};

export default ConfirmDeleteModal;



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/ConfirmDeleteModal.js